import { useEffect, useState } from 'react';
import {
  EXPIRY_WARNING_HOURS,
  expiryNotice,
  hoursUntilExpiry,
} from '../../audit/expiry';

/**
 * "53 hours until this audit expires" on every in-progress audit (owner
 * ask 2026-10-15) — Audits hub rows and the conduct page's sticky
 * sidebar/toolbar. Refreshes each minute; red in the final
 * EXPIRY_WARNING_HOURS.
 */
export function ExpiryNotice({
  startedAt,
  variant = 'inline',
}: {
  startedAt: string;
  /** inline = text within a row; panel = the conduct page's sticky chip. */
  variant?: 'inline' | 'panel';
}) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 60_000);
    return () => clearInterval(id);
  }, []);

  const text = expiryNotice(startedAt, now);
  if (!text) return null;
  const left = hoursUntilExpiry(startedAt, now);
  const urgent = left !== null && left < EXPIRY_WARNING_HOURS;

  if (variant === 'panel') {
    return (
      <div className={`expiry-notice${urgent ? ' expiry-urgent' : ''}`} role="status">
        ⏳ {text}
      </div>
    );
  }
  return urgent ? <span className="error">{text}</span> : <>{text}</>;
}
